import { InputLabel, Rating, Typography } from '@mui/material'
import React from 'react'

type RatingProps = {
    title: string,
    field: any,
    errors: any
}

const CustomRating = ({title, field, errors} : RatingProps) => {
    return (
        <div>
            <InputLabel sx={{ fontWeight: "bold"}} >{title}</InputLabel>
            <Rating
                {...field}
                value={field.value || 0}
                onChange={(_, value) => field.onChange(value || 0)}
                max={5}
            /> 
            {errors.rating && (
                <Typography style={{ color: "red", fontSize: "0.8rem", paddingBottom: "10px" }}>
                    {errors.rating.message}
                </Typography>
            )}
        </div>
    )
}

export default CustomRating